import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { ApolloProvider } from '@apollo/client';
import { ThemeProvider, CssBaseline } from '@mui/material';
import AppLayout from './layout/AppLayout.jsx';
import HybridAuthModal from './auth/HybridAuthModal';
import apolloClient from './graphql/apollo-client';
import healthcareTheme from './theme/healthcareTheme';
import './App.css';

function App() {
  return (
    <div className="App">
      <ThemeProvider theme={healthcareTheme}>
        <CssBaseline />
        <ApolloProvider client={apolloClient}>
          <Router>
            <AppLayout />
            <HybridAuthModal />
          </Router>
        </ApolloProvider>
      </ThemeProvider>
    </div>
  );
}

export default App;